import { Api } from "../config/request";

export default {
  getUserAttributeList(queryParams) {
    return Api.get(`/user-attributes/list?${queryParams}`);
  },
  getActionTypeList(queryParams) {
    return Api.get(`/user-attributes/list-actions?${queryParams}`);
  },
  createAttributeMapping(payload) {
    return Api.post("/user-attributes/create", payload);
  },
  updateAttributeMapping(payload) {
    return Api.put("/user-attributes/update", payload);
  },
};
